import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { getDraftKey, type ImportDraft } from "../libraryImportParsing";

export const InvalidDraftsDialog = ({
  open,
  onOpenChange,
  invalidDrafts,
  validDraftCount,
  invalidIssueCounts,
  drafts,
  onJump,
  onJumpKeyDown,
  onExclude,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invalidDrafts: ImportDraft[];
  validDraftCount: number;
  invalidIssueCounts: Array<[string, number]>;
  drafts: ImportDraft[];
  onJump: (draftKey: string, label: string) => void;
  onJumpKeyDown: (event: React.KeyboardEvent<HTMLButtonElement>, draftKey: string, label: string) => void;
  onExclude: () => void;
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Fix or exclude invalid rows before import</AlertDialogTitle>
        <AlertDialogDescription>
          {invalidDrafts.length} row{invalidDrafts.length === 1 ? " is" : "s are"} still flagged with invalid ISBN data. Fix them in the review list or continue with only the valid rows.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <div className="space-y-3 text-sm text-muted-foreground">
        <div className="space-y-1">
          {invalidIssueCounts.map(([issue, count]) => (
            <p key={issue}>{count} × {issue}</p>
          ))}
        </div>
        <div className="space-y-1">
          {invalidDrafts.slice(0, 5).map((draft) => {
            const draftIndex = drafts.findIndex((entry) => entry === draft);
            const draftKey = getDraftKey(draft, draftIndex);
            return (
              <button
                key={draftKey}
                type="button"
                className="block text-left text-primary hover:underline"
                aria-label={`Jump to invalid row ${draft.title || draft.importLabel}`}
                onClick={() => onJump(draftKey, draft.title || draft.importLabel)}
                onKeyDown={(event) => onJumpKeyDown(event, draftKey, draft.title || draft.importLabel)}
              >
                <span className="font-medium text-foreground">{draft.title}</span> · {draft.importLabel}
              </button>
            );
          })}
          {invalidDrafts.length > 5 ? <p>+{invalidDrafts.length - 5} more invalid rows</p> : null}
        </div>
      </div>
      <AlertDialogFooter>
        <AlertDialogCancel>Go back and fix rows</AlertDialogCancel>
        <AlertDialogAction onClick={onExclude} disabled={validDraftCount === 0}>
          Exclude invalid rows and import {validDraftCount} valid record{validDraftCount === 1 ? "" : "s"}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
